import {
  useTheme,
  Paper,
  Box,
  Alert,
  Typography,
  CircularProgress,
} from '@mui/material';

import ChatLine from './ChatLine';
import type { ChatItem, ChatItemUpdateRequest } from '@/types/apiTypes';
import type { EntityId } from '@/types';

interface ChatBoxProps {
  chat_history: ChatItem[];
  generation?: string;
  isSearching: boolean;
  updateChatLine: (id: EntityId, data: ChatItemUpdateRequest) => Promise<void>;
}

function ChatBox({ chat_history, generation, isSearching, updateChatLine }: ChatBoxProps) {
  const theme = useTheme();

  return (
    <Paper
      sx={{
        margin: '10px',
        backgroundColor: theme.palette.grey[100],
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {chat_history.length ? (
        <Box
          sx={{
            p: 2,
          }}
        >
          {chat_history.map((line) => (
            <ChatLine
              key={`message_${line.entity_id}`}
              line={line}
              updateChatLine={updateChatLine}
            />
          ))}
          {isSearching && !generation ? (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                p: 2,
                justifyContent: 'flex-end',
              }}
            >
              <CircularProgress size={16} />
              <Typography variant='body2' color='text.secondary'>
                Searching...
              </Typography>
            </Box>
          ) : generation ? (
            <ChatLine
              key={`message_generating`}
              line={{ role: 'assistant', content: generation }}
              updateChatLine={updateChatLine}
            />
          ) : undefined}
        </Box>
      ) : (
        <Box
          sx={{
            p: 2,
            borderRadius: '20px 20px 20px 20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '400px',
          }}
        >
          <Alert severity='info'>Ask a question to get started</Alert>
        </Box>
      )}
    </Paper>
  );
}

export default ChatBox;

